angular.module("digitalLeasing.module").component("notes", {
    templateUrl: "ng/components/digitalLeasing/settingProductsRange/notes/notes.view.html",
    bindings: {
        model: "=", //richiestaConvenzionePlafond
    },
    controllerAs: "notesCtrl",
    controller: NotesController
});

function NotesController() {
    var self = this;

    self.$onInit = function () {};

    self.handleChange = function (value) {
        if (value) {
            self.model.note = value;
        }
    }
}